import React, { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import { Card, CardContent, CardHeader, Typography, Divider, Grid } from "@mui/material";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";

import MappingToolBar from "../../../../components/MappingToolbar";
import MapOttPlanModal from "./MapOttPlanModal";
import { useDialog } from "../../../../contexts/DialogContext";
import { getTimeStamp } from "../../../../utils/common";
import MappedPlan from "./MappedPlan";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import CustomTextField from "../../../../components/CustomTextField";
import usePlanGroup from "../../../../hooks/usePlanGroup";
import OttPlanTable from "./OttPlanTable";

const AllowedOttPlan = ({ planGroupId, isSharingAllowed, serviceType, validationFields }) => {
  const {
    formState: { errors },
    control,
    watch,
    setValue,
  } = useFormContext();
  const { openDialog } = useDialog();
  const { t } = useTranslation();

  const sharingType = watch("sharingType");

  const ottMsoSharing = watch("ottMsoSharing");
  const ottDistSharing = watch("ottDistSharing");
  const ottLcoSharing = watch("ottLcoSharing");
  const planGroupOttPlans = watch("planGroupOttPlans");

  const ottMsoSharingName = ottMsoSharing + "%";
  const ottDistSharingName = ottDistSharing + "%";
  const ottLcoSharingName = ottLcoSharing + "%";
  const openDownloadDialog = () => {
    return openDialog(
      "map_ott_plan_modal",
      "Map OTT Plan Modal",
      <MapOttPlanModal
        planGroupId={planGroupId}
        key={getTimeStamp()}
        isNew={true}
        isSharingAllowed={isSharingAllowed}
        multiple={sharingType == "FIXED"}
        sharingType={sharingType}
        ottMsoSharing={ottMsoSharing}
        ottDistSharing={ottDistSharing}
        ottLcoSharing={ottLcoSharing}
        serviceType={serviceType}
        setPlanGroupPlanValues={setValue}
        planGroupOttPlans={planGroupOttPlans}
      />,
      "lg",
    );
  };

  useEffect(() => {
    if (sharingType == "FIXED") {
      const updatedPlans = planGroupOttPlans.map((plan) => ({
        ...plan, // keep existing planId or other fields
        ottMsoSharing,
        ottDistSharing,
        ottLcoSharing,
        ottMsoSharingName,
        ottDistSharingName,
        ottLcoSharingName,
      }));
      setValue("planGroupOttPlans", updatedPlans);
    }
  }, [ottMsoSharing, ottDistSharing, ottLcoSharing]);

  return (
    <Card mb={6}>
      <CardHeader action={<MappingToolBar openDialog={openDownloadDialog} />} />

      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t("Sharing")}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={12} className="row" pt={8} id="ott_sharing">
          {isSharingAllowed && (
            <Grid item md={3}>
              <CustomTextField
                label={t("ottMsoSharing")}
                name="ottMsoSharing"
                type="text"
                my={2}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={validationFields}
                disabled={sharingType == "POLICY_WISE"}
              />
            </Grid>
          )}
          {isSharingAllowed && (
            <Grid item md={3}>
              <CustomTextField
                label={t("ottDistSharing")}
                name="ottDistSharing"
                type="text"
                my={2}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={validationFields}
                disabled={sharingType == "POLICY_WISE"}
              />
            </Grid>
          )}
          {isSharingAllowed && (
            <Grid item md={3}>
              <CustomTextField
                label={t("ottLcoSharing")}
                name="ottLcoSharing"
                type="text"
                my={2}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={validationFields}
                disabled={sharingType == "POLICY_WISE"}
              />
            </Grid>
          )}
        </Grid>

        <OttPlanTable />
      </CardContent>
    </Card>
  );
};

export default AllowedOttPlan;
